import CssIcon from '../CssIcon'

export default function render(props) {
	const { label, errorMsg, type, name, value, onChange } = props;

	return (
		<div className={errorMsg ? 'InputField error' : 'InputField'}>
			<input
				type={type}
				name={name}
				value={value}
				onChange={onChange}
				placeholder=" "
				required=" "
			/>
			<label htmlFor={name}>
				{label}
				{errorMsg && (
					<span>
						<CssIcon type="input-cross" color="white" width="12" height="12" />
						{errorMsg}
					</span>
				)}
			</label>
		</div>
	);
}
